import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '27',
  height: '32',
  viewBox: '-1 -1 29 34'
}, [
  h('g', {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: '#8091A5'
  }, [
    h('path', {
      d: 'M26.6 19.4c0 1-.8 1.8-1.8 1.8s-1.8-.8-1.8-1.8v-8.1c0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8v8.1zM4 19.4c0 1-.8 1.8-1.8 1.8S.4 20.4.4 19.4v-8.1c0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8v8.1zM17.6 2.7L19 .6c0-.1 0-.1-.1-.2s-.2-.1-.2 0l-1.5 2.1c-1-.4-2.2-.6-3.7-.6s-2.8.2-3.8.6L8.2.4c0-.1-.1 0-.2 0-.1.1-.2.1-.2.2l1.5 2C5.1 4.5 5 9 5 9h17c-.1 0-.2-4.5-4.4-6.3zM9.7 6.4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1c.1.5-.4 1-1 1zm7.5 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1c0 .5-.5 1-1 1zM22 10.1H4.9v14.3c0 .6.4 1 1 1h2.2v4.5c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-4.5h3.4v4.5c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-4.5H21c.6 0 1-.4 1-1V10.1'
    })
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/language-android.es6.js